exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container[data-v-fcf8c150]{max-width:1200px;overflow:hidden}.layout[data-v-fcf8c150]{-ms-flex-align:center;align-items:center}.http-code[data-v-fcf8c150]{font-size:10rem;font-weight:700;background-color:#02648e;color:transparent;text-shadow:2px 2px 2px hsla(0,0%,100%,.5);-webkit-background-clip:text;background-clip:text;text-align:right}.error-msg[data-v-fcf8c150]{font-size:4rem;padding:2rem;text-align:left;text-shadow:1px 1px 1px rgba(0,0,0,.5)}.action button[data-v-fcf8c150],.error-msg[data-v-fcf8c150]{font-weight:700;color:#00638e}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-fcf8c150","scoped":true,"sourceMap":false}!./~/postcss-loader/lib!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/HTTPError.vue
// module id = 1059
// module chunks = 22